import { styled } from '@mui/system';

const HomeRootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '12px',
  backgroundColor: '#F5F5F5',
  paddingBottom: '20px',
});

const SidePadding = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '4%',
  paddingRight: '4%',
  backgroundColor: '#F5F5F5',
});

const CarouselsContainer = styled('div')({
  '&:last-child': {
    marginBottom: '-20px',
  },
});

export { HomeRootDiv, SidePadding, CarouselsContainer };
